import Agreement from './agreement';
import ChannelDistribution from './channel-distribution';
import Contract from './contract';
import DigitalDistribution from './digital-distribution';
import ExtendedList from './list/ContractExtendedTemplates';
import List from './list/ContractTemplates';
import MerchDistribution from './merch-distribution';
import ParagraphSection from './paragraph-section';
import PhysicalDistribution from './physical-distribution';
import Section from './section';

export default {
  List,
  ExtendedList,
  Agreement,
  Section,
  ParagraphSection,
  DigitalDistribution,
  Contract,
  PhysicalDistribution,
  MerchDistribution,
  ChannelDistribution,
};
